import i18n from "~/language";
import { IGroupSrr } from "~/pages/SRR/model/types";

const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
const dealerArrSRR3 = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];
const cityArr = ["city", "subject", "FO"];
const foArr = ["FO"];
const regionArr = ["subject", "FO"];
const dealerArrAKC = ["DealerName", "INN", "ent_id", "City", "subject", "FO"];
const cityArrAKC = ["City", "subject", "FO"];
const regionArrAKC = ["subject", "FO"];
const foArrAKC = ["FO"];
const CountryArrAKC = ["Country"];
const carsArr = ["modelName"];
// const availableTO = ["TO-0", "TO-1", "TO-2", "TO-3", "TO-4", "TO-5", "TO-6", "TO-7", "TO-8"];

const getElementsUntilName = (arr: string[], name: string) => {
  const index = arr.indexOf(name);
  if (index !== -1) {
    return arr.slice(0, index + 1);
  } else {
    return arr;
  }
};

/**
 * Возвращает строку для перевода по ключу селекта из поля фильтра Вид отчета
 */
export const selectLangByViewKey = {
  Period: "evaluationPeriod",
  Kind: "kinds",
  FamilyCar: "CarModel",
};

export const getTableHeaders = (
  valueReport: string,
  tableRows: any[],
  groupSrr: IGroupSrr,
  nameColumnChildren: string[],
  reportConfigData,
) => {
  let optionsTable = [];
  let optionsTableChildren = [];
  let arrTableRowsPeriod = [];

  const arrNotGroup = [
    "ReportReturnCarServiceDynamics",
    "ReportReturnCarAverageDailyMileageByMonth",
    "ReportReturnClientsWithoutService",
    "ReportReturnSRR3ByDealer",
    "ReportReturnSRR3ByPeriod",
    "ReportReturnSRR3ForPayments",
    "ReportReturnSRR3ByCar",
    "ReportReturnSRR5ByCar",
    "ReportReturnSRR3ByVIN",
    "ReportReturnSRR5ByDealer",
    "ReportReturnSRR5ByPeriod",
    "ReportReturnSRR5ForPayments",
    "ReportReturnSRR3GIBDDByDealer",
    "ReportReturnSRR5GIBDDByDealer",
    "ReportReturnSRR3GIBDDByPeriod",
    "ReportReturnSRR5GIBDDByPeriod",
    "InvitationOfClientsForMaintenance",
    "ReportNSByDealer",
    "ReportNSByConsultant",
    "ReportNSByClient",
    "ReportNSByWarmClients",
    "ReportNSByOldClients",
    "ReportNSByAverageCarAge",
    "ReportNSByClientCarSale",
    "TOMonthOfControlMine",
    "TOOwnBySalesPeriod",
    "warrantyRepairMonthOfControl",
    "TOMonthOfControlFriendOrFoe",
    "TOMonthOfControlFriendOrFoeByCarFamily",
    "TOFriendOrFoeBySalesPeriod",
    "TOFriendOrFoeByPeriodByCarFamily",
    "warrantyRepairBySalesPeriod",
    "TOMonthOfControlCarFamilyRegion",
    "ReportReturnCarServiceByDealer",
    "ReportReturnSRR3ForPayments",
    "ReportReturnSRR3ByCar",
    "ReportReturnSRR5ByCar",
    "ReportAverageReceiptTO",
    "ReportReturnAverageReceiptAKC",
    "ReportReturnSRR3ByDealer",
  ];

  const arrGroupAkc = [
    "ReportAverageReceiptTO",
    "ReportReturnAverageReceiptAKC",
  ];

  const arrNoGroupTO = [
    "ReportReturnCarServiceByDealer",
    "ReportReturnSRR3ByPeriod",
    "ReportReturnSRR3GIBDDByPeriod",
    "ReportReturnSRR5GIBDDByPeriod",
    "TOReturnCarForServiceByPeriodConsolidated",
    "ReportReturnSRR5ByPeriod",
    "ReportReturnSRR3ByPeriod",
    "InvitationOfClientsForMaintenance",
    "TOOwnBySalesPeriod",
    "warrantyRepairMonthOfControl",
    "TOMonthOfControlFriendOrFoe",
    "TOMonthOfControlFriendOrFoeByCarFamily",
    "TOFriendOrFoeBySalesPeriod",
    "TOFriendOrFoeByPeriodByCarFamily",
    "warrantyRepairBySalesPeriod",
    "TOMonthOfControlCarFamilyRegion",
    "ReportReturnSRR3ForPayments",
    "ReportReturnSRR5ForPayments",
    "ReportReturnSRR3ByCar",
    "ReportReturnSRR5ByCar",
    "TOMonthOfControlMine",
    "ReportReturnSRR3ByDealer",
    "ReportReturnSRR5ByDealer",
  ];

  const arrGroupByPeriod = [
    // "ReportReturnSRR3ForPayments",
    // "ReportReturnSRR5ForPayments",
    // "ReportReturnSRR3ByCar",
    // "ReportReturnSRR5ByCar",
  ];

  switch (!arrNotGroup.includes(valueReport) && groupSrr["group"]) {
    case "dealer":
      optionsTable = dealerArr;
      optionsTableChildren = dealerArr;

      break;
    case "city":
      optionsTable = cityArr;
      optionsTableChildren = cityArr;
      break;
    case "fo":
      optionsTable = foArr;
      optionsTableChildren = foArr;
      break;
    case "region":
      optionsTable = regionArr;
      optionsTableChildren = regionArr;
      break;
    case "cars":
      optionsTable = carsArr;
      optionsTableChildren = carsArr;
      break;
  }

  // const dealerArrAKC = ["DealerName", "INN", "code"];
  // const cityArrAKC = ["City"];
  // const foArrAKC = ["FO"];
  // const regionArrAKC = ["FO"];
  // const CountryArrAKC = ["Country"];

  switch (arrGroupAkc.includes(valueReport) && groupSrr["group"]) {
    case "dealer":
      optionsTable = dealerArrAKC;
      break;
    case "city":
      optionsTable = cityArrAKC;

      break;
    case "fo":
      optionsTable = foArrAKC;

      break;
    case "region":
      optionsTable = regionArrAKC;
      break;
    case "country":
      optionsTable = CountryArrAKC;

      break;
  }

  if (valueReport === "ReportReturnUniqueService") {
    const cellName =
      reportConfigData && reportConfigData.kindReport
        ? selectLangByViewKey[reportConfigData.kindReport.value]
        : "";
    optionsTable = [cellName, "ten_year", i18n.t("srr.VINByYearsOfOwnership")];
    optionsTableChildren = [
      cellName,
      "ten_year",
      "1stYear",
      "2ndYear",
      "3rdYear",
      "4thYear",
      "5thYear",
      "6thYear",
      "7thYear",
      "8thYear",
      "9thYear",
      "10thYear",
    ];
    arrTableRowsPeriod.push(i18n.t("srr.VINByYearsOfOwnership"));

    //asdf
    console.log("<<<<<<<<<<");
    return [optionsTable, optionsTableChildren, arrTableRowsPeriod];
  }

  if (valueReport === "ReportReturnCarServiceDynamics") {
    optionsTable = ["period", "AllTO", "Warranty", "writ"];
    optionsTableChildren = ["period", "AllTO", "Warranty", "writ"];
  }

  if (
    ["ReportReturnSRR5GIBDDByDealer"].includes(valueReport) &&
    tableRows.length > 0
  ) {
    optionsTableChildren = dealerArr;
    for (let i = 0; 6 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = [groupSrr["monthControl"]];
    optionsTable = [
      ...dealerArrSRR3,
      "TO1",
      "TO2",
      "TO3",
      "TO4",
      "TO5",
      groupSrr["monthControl"],
    ];
  }

  if (
    ["ReportReturnSRR3GIBDDByDealer"].includes(valueReport) &&
    tableRows.length > 0
  ) {
    optionsTableChildren = dealerArr;
    for (let i = 0; 4 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = [groupSrr["monthControl"]];
    optionsTable = [
      ...dealerArrSRR3,
      "TO1",
      "TO2",
      "TO3",
      groupSrr["monthControl"],
    ];
  }

  if (
    (valueReport === "ReportReturnSRR3ByPeriod" ||
      valueReport === "ReportReturnSRR3GIBDDByPeriod") &&
    nameColumnChildren
  ) {
    optionsTableChildren = ["period"];
    for (let i = 0; 4 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = ["TO1", "TO2", "TO3", "SRR"];
    optionsTable = ["period", "TO1", "TO2", "TO3", "SRR"];
  }

  if (
    (valueReport === "ReportReturnSRR5ByPeriod" ||
      valueReport === "ReportReturnSRR5GIBDDByPeriod") &&
    nameColumnChildren
  ) {
    optionsTableChildren = ["period"];
    for (let i = 0; 6 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = ["TO1", "TO2", "TO3", "TO4", "TO5", "SRR"];
    optionsTable = ["period", "TO1", "TO2", "TO3", "TO4", "TO5", "SRR"];
  }

  if (["ReportReturnSRR3ByVIN"].includes(valueReport) && nameColumnChildren) {
    optionsTableChildren = optionsTable = [
      "ent_id",
      "INN",
      "DealerName",
      "dateSales",
      "VIN",
      "model",
      "eqFamilyCode",
      "eqVariant",
      "name",
      "phone",
    ];
    for (let i = 0; 3 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = ["TO1", "TO2", "TO3"];
    optionsTable = [
      "ent_id",
      "INN",
      "DealerName",
      "dateSales",
      "VIN",
      "model",
      "eqFamilyCode",
      "eqVariant",
      "name",
      "phone",
      "TO1",
      "TO2",
      "TO3",
    ];
  }

  if (["ReportReturnSRR5ByVIN"].includes(valueReport) && nameColumnChildren) {
    optionsTableChildren = [
      ...[
        "ent_id",
        "INN",
        "DealerName",
        "dateSales",
        "VIN",
        "model",
        "eqFamilyCode",
        "eqVariant",
        "name",
        "phone",
      ],
    ];
    optionsTable = [
      "ent_id",
      "INN",
      "DealerName",
      "dateSales",
      "VIN",
      "model",
      "eqFamilyCode",
      "eqVariant",
      "name",
      "phone",
    ];
  }

  if (valueReport === "ReportReturnCarAverageDailyMileageByMonth") {
    optionsTable = carsArr;
    optionsTableChildren = carsArr;
  }
  if (valueReport === "ReportAverageReceiptTO") {
    const customHeader = [
      // "dealerName",
      // "city",
      // "INN",
      // "uniqueCode",
      // "subject1",
      // "fo",
      "numberOfCarsArrivedOnTO1-TO12",
      "totalSalesAmountSparePartsAndMaterialsMaintenance",
      "averageCheck",
    ];
    optionsTable = [...optionsTable, ...customHeader];
    optionsTableChildren = [];
  }
  if (valueReport === "ReportReturnAverageReceiptAKC") {
    const customHeader = [
      // "dealerName",
      // "city",
      // "INN",
      // "uniqueCode",
      // "subject1",
      // "fo",
      "totalSalesAmountAccessoriesAndDO",
      "soldCars",
      "averageCheck",
    ];
    optionsTable = [...optionsTable, ...customHeader];
    optionsTableChildren = [];
  }
  if (valueReport === "InvitationOfClientsForMaintenance") {
    optionsTable = [
      "car",
      "fio",
      "phone",
      "email",
      "agree",
      "dataSales",
      "maxDateVisit",
      "avgRun",
      "lastComment",
      "prevTODealer",
      "prevToText",
      "nextToDate",
    ];
  }

  if (valueReport === "ReportReturnClientsWithoutService") {
    optionsTable = ["period", "monthSale", "NoWarranty"];
    optionsTableChildren = [
      "period",
      "monthSale",
      "countCar",
      "withoutServices",
      "percent",
    ];
  }

  if (
    groupSrr["arrTO"].length > 0 &&
    !arrNoGroupTO.includes(valueReport) &&
    nameColumnChildren
  ) {
    for (let i = 0; groupSrr["arrTO"].length > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    optionsTable = [...optionsTable, ...groupSrr["arrTO"]];
  }

  if (
    groupSrr["arrTO"].length > 0 &&
    valueReport === "TOReturnCarForServiceByPeriodConsolidated"
  ) {
    optionsTable = ["cars", "client", "dealer"];
    arrTableRowsPeriod = ["cars", "client", "dealer"];
    optionsTableChildren = [
      "vin",
      "eqFamilyCode",
      "eqNumber",
      "eqVariant",
      "familyCar",
      "dateSales",
      "ClientName",
      "phone",
      "email",
      "dealerName",
      "INN",
      "city",
    ];

    for (let i = 0; groupSrr["arrTO"].length > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }
    arrTableRowsPeriod = [...arrTableRowsPeriod, ...groupSrr["arrTO"]];
    optionsTable = [...optionsTable, ...groupSrr["arrTO"]];
  }

  // if (groupSrr["arrGO"].length > 0) {
  //   for (let i = 0; groupSrr["arrGO"].length > i; i++) {
  //     optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
  //   }
  //   optionsTable = [...optionsTable, ...groupSrr["arrGO"]];
  // }

  // if (
  //   valueReport === "ReportReturnCarServiceByDealer" &&
  //   tableRows.length > 0 &&
  //   tableRows[0]["periods"].length > 0
  // ) {
  //   for (let i = 0; tableRows[0]["periods"].length > i; i++) {
  //     optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
  //   }
  //
  //   const arrTableRows = tableRows[0]["periods"].map((el) => el["period"]);
  //
  //   arrTableRowsPeriod = [...arrTableRows];
  //   optionsTable = [...optionsTable, ...arrTableRows];
  // }

  if (
    arrGroupByPeriod.includes(valueReport) &&
    tableRows.length > 0 &&
    tableRows[0]["periods"].length > 0
  ) {
    optionsTableChildren = dealerArr;

    for (let i = 0; tableRows[0]["periods"].length + 1 > i; i++) {
      optionsTableChildren = [...optionsTableChildren, ...nameColumnChildren];
    }

    const arrTableRows = tableRows[0]["periods"].map((el) => el["period"]);

    arrTableRowsPeriod = [
      ...arrTableRows,
      `${arrTableRows[0]}/${arrTableRows[arrTableRows.length - 1]}`,
    ];

    optionsTable = [
      ...dealerArr,
      ...arrTableRows,
      `${arrTableRows[0]}/${arrTableRows[arrTableRows.length - 1]}`,
    ];
  }
  // ИСКЛЮЧИТЬ из шапки ReportReturnLoyaltyServiceByDealer ТО метки, но не для остальных
  if (valueReport === "ReportReturnLoyaltyServiceByDealer") {
    return [[], [], []];
  }

  return [optionsTable, optionsTableChildren, arrTableRowsPeriod];
};
